import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { cafeInfo } from "@/data/menu";
import Footer from "@/components/Footer";

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="bg-white min-h-screen">
      <header className="border-b border-warm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10">
          <Link
            to="/"
            data-testid="impressum-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-brand link-underline"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
          <Link
            to="/"
            className="font-display text-2xl font-extrabold tracking-tight text-brand"
          >
            {cafeInfo.name}
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-20 md:px-10 md:py-28">
        <span className="eyebrow">Rechtliches</span>
        <h1
          data-testid="impressum-heading"
          className="font-display mt-4 text-5xl font-bold tracking-tight text-brand md:text-6xl"
        >
          Impressum
        </h1>
        <p className="mt-6 text-base text-[#5c5752]">
          Angaben gemäß § 5 TMG
        </p>

        <section className="mt-12 space-y-10">
          <div>
            <h2 className="eyebrow">Inhaber</h2>
            <p
              data-testid="impressum-owner"
              className="font-display mt-3 text-2xl font-semibold text-brand"
            >
              {cafeInfo.imprint.owner}
            </p>
            <p className="mt-2 text-base text-[#5c5752]">
              {cafeInfo.imprint.address}
            </p>
          </div>

          <div>
            <h2 className="eyebrow">Kontakt</h2>
            <div className="mt-3 space-y-1">
              <p className="text-base text-brand">
                Telefon:{" "}
                <a
                  href={cafeInfo.phoneHref}
                  className="link-underline"
                  data-testid="impressum-phone"
                >
                  {cafeInfo.imprint.phone}
                </a>
              </p>
              <p className="text-base text-brand">
                E-Mail:{" "}
                <a
                  href={`mailto:${cafeInfo.imprint.email}`}
                  className="link-underline"
                  data-testid="impressum-email"
                >
                  {cafeInfo.imprint.email}
                </a>
              </p>
            </div>
          </div>

          <div>
            <h2 className="eyebrow">Umsatzsteuer-Identifikationsnummer</h2>
            <p
              data-testid="impressum-vat"
              className="mt-3 text-base text-brand"
            >
              {cafeInfo.imprint.vatId}
            </p>
          </div>

          <div>
            <h2 className="eyebrow">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="mt-3 text-base text-brand">
              {cafeInfo.imprint.owner}
              <br />
              {cafeInfo.imprint.address}
            </p>
          </div>

          <div>
            <h2 className="eyebrow">Streitschlichtung</h2>
            <p className="mt-3 text-base leading-relaxed text-[#5c5752]">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline text-brand"
              >
                ec.europa.eu/consumers/odr
              </a>
              . Unsere E-Mail-Adresse findest du oben im Impressum. Wir sind
              nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          <div>
            <h2 className="eyebrow">Haftung für Inhalte</h2>
            <p className="mt-3 text-base leading-relaxed text-[#5c5752]">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen.
            </p>
          </div>

          <div>
            <h2 className="eyebrow">Urheberrecht</h2>
            <p className="mt-3 text-base leading-relaxed text-[#5c5752]">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
